<template>
  <v-card flat>
    <v-card-title class="subtitle-2 pb-1">Контакты приемной комиссии КузГТУ</v-card-title>
    <v-card-text>
      Электронная почта: <a v-bind:href="'mailto:abit@kuzstu.ru'">abit@kuzstu.ru</a><br>
      Телефон: <a v-bind:href="'tel:+73842682424'">+7 (3842) 68-24-24</a><br>
    </v-card-text>
  </v-card>
</template>

<script>
  export default {
    name: "ContactCard"
  }
</script>

<style scoped>

</style>
